import React, { Fragment } from "react";
import Header from "../../components/header/Header";
import Scrollbar from "../../components/scrollbar/scrollbar";
import Footer from "../../components/footer/Footer";
import Bg from "../../images/bg/page_bg01.jpg";
import CtaSection from "../../components/CtaSection/CtaSection";
import icon from "../../images/icon/magic-icon.svg";
import officeIMG from "../../images/about/office.jpg";


const AboutUsPage = (props) => {
  return (
    <Fragment>
      <div className="body_wrap sco_agency">
        <Header />
        <section
          className="page-title pt-120 pos-rel bg_img"
          style={{ backgroundImage: `url(${Bg})` }}
        >
          <div className="container">
            <div className="page-title-wrap">
              <div className="row mt-none-30 align-items-center text-center">
                <div className="col-xl-12 col-lg-8 mt-30">
                  <div className="page-title-box">
                    <span className="sub-title">
                      About Tigris Pay
                    </span>
                    <h2 className="title">
                      Fast, Secure & Reliable Money <br />
                      Transfers with Tigris Pay
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="about-video pt-75">
          <div className="container">
            <div className="career_video">
              
                <img src={officeIMG} alt="" />
                {/* <source src={Video} type="video/mp4" />
                Your browser does not support the video tag. */}
              
            </div>
          </div>
        </div>
        <div className="sd-ser-content_wrap pt-80 pb-110">
          <div className="container">
            <div className="sd-ser-content">
              <h2 className="sd-title">
                We are Tigris Pay
              </h2>
              <p className="sd-content fs-5">
                At <strong>Tigris Pay</strong>, we are committed to making international money transfers simple and stress-free. Our platform offers secure and seamless solutions for individuals in the UK to send money to <strong>Bangladesh, India, Nepal, Pakistan and Sri Lanka</strong>. Whether you’re sending funds to family or managing cross-border payments, Tigris Pay ensures your money moves quickly, safely, and with complete confidence.

              </p>
              <br />
              <p className="sd-content fs-5">
            We specialise in international remittances across the <strong>UK–South Asia corridor</strong>, combining advanced security measures, real-time transaction tracking, and competitive exchange rates. With Tigris Pay, you’re not just sending money — you’re sending it with trust, transparency, and control.
              </p>
                <br />
              <p className="sd-content fs-5">
             Our approach is built on <strong>transparency, speed, and customer satisfaction</strong>. From an easy-to-use platform and flexible payment options to responsive customer support, we make cross-border transfers effortless. Whether it’s family remittances, tuition fees, or other international payments, Tigris Pay is designed to meet your needs.
              </p>
               <br />
               <p className="sd-content fs-5">
             Join a growing community of users who trust Tigris Pay for their international transfers. Experience a smarter way to send money — fast, secure, and built around you.
              </p>
            </div>
          </div>
        </div>

        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};
export default AboutUsPage;
